export default {
  methods: {
    openJivoChat(evt, message = 'Здравствуйте, могу ли я чем-то помочь?') {
      switch (true) {
        case !window.isJivoInit:
          break
        case window.isJivoMobile && (window.isJivoWasOpen || window.jivo_config.chat_mode === 'offline'):
          window.jivo_api.open()
          break
        case window.isJivoMobile:
          window.jivo_api.showProactiveInvitation(message)
          window.isJivoWasOpen = true
          break
        case window.jivo_config.chat_mode === 'offline' && !window.isJivoOpen:
          window.jivo_api.open()
          break
        case window.isJivoOpen:
          // eslint-disable-next-line no-case-declarations
          const jivoBackground = document.querySelector('#jcont')
          if (jivoBackground) {
            jivoBackground.style.borderTopLeftRadius = '8px'
            jivoBackground.style.borderTopRightRadius = '35px'
            jivoBackground.style.transition = 'box-shadow 0.3s ease'
            jivoBackground.style.boxShadow = '0 20px 40px 8px #EB4247'

            setTimeout(() => {
              jivoBackground.style.boxShadow = ''
            }, 300)
            setTimeout(() => {
              jivoBackground.style.transition = ''
            }, 600)
          }
          break
        case window.isJivoWasOpen:
          window.jivo_api.open()
          break
        case !window.isJivoWasOpen:
          window.jivo_api.showProactiveInvitation(message)
          break
      }
    }
  }
}